import { ROLE_WEB_EDITOR, ROLE_COMPETITOR_ANALYST, ROLE_ROUTING_TOOL_EDITOR, ROLE_CMS_EDITOR } from '@/util/constants'

const isAuthenticated = state => state.isAuthenticated

const isInRole = (state) => (role) => {
  let is = false
  state.roles.forEach(function (r) {
    if (r === role) {
      is = true
    }
  })
  return is
}

const isWebEditor = (state, getters) => () => {
  return getters.isInRole(ROLE_WEB_EDITOR)
}

const isCompetitorAnalyst = (state, getters) => () => {
  return getters.isInRole(ROLE_COMPETITOR_ANALYST)
}

const isRoutingToolEditor = (state, getters) => () => {
  let is = getters.isInRole(ROLE_ROUTING_TOOL_EDITOR)
  return is
}

const isCmsEditor = (state, getters) => () => {
  return getters.isInRole(ROLE_CMS_EDITOR)
}

export default {
  isAuthenticated,
  isInRole,
  isWebEditor,
  isCompetitorAnalyst,
  isRoutingToolEditor,
  isCmsEditor
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js